import Cookies from 'js-cookie'
const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    jieci:'', // "第16届", 默认届次
		lunci:'', // "第20轮", 默认轮次
    hierarchy:'selfHierarchy', // 默认本级
    inspectionMethod:'', // 巡视方式，默认全部
    optionsList: [],
    PaiList: []
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
		setJieci(state,val){
			state.jieci = val
		},
		setLunci(state,val){
			state.lunci = val
		},
    setHierarchy(state,val){
			state.hierarchy = val
    },
    setInspectionMethod(state,val){
    	state.inspectionMethod = val
    },
    setOptionsList(state, val) {
      state.optionsList = val
    },
    setPaiList(state, val) {
      state.PaiList = val
    }
  },
  actions: {   //一般在action中提交mutation,需要被分发dispatch
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js